import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Popper from "@mui/material/Popper";
import { styled } from "@mui/material/styles";
const filter = createFilterOptions();

export default function FreeSoloCreateOption({ setReasonCanceling }) {
  const [value, setValue] = useState(null);
  const [checkedNoShow, setCheckedNoShow] = useState(false);
  const [canceled, setCanceled] = useState(false);

  const reasons = [
    { title: "Zdravstven problemi" },
    { title: "Putovanje" },
    { title: "Other" },
  ];

  const StyledPopper = styled(Popper)({
    height: "120px",
    overflowY: "auto",
  });

  const handleChangeChecked = (e) => {
    setCheckedNoShow(e.target.checked);
    setCanceled(false);
  };
  const handleChangeCanceled = (e) => {
    setCanceled(e.target.checked);
    setCheckedNoShow(false);
  };

  return (
    <div
      style={{
        height: "auto",
        marginTop: "5px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Autocomplete
        PopperComponent={StyledPopper}
        ListboxProps={{
          style: {
            maxHeight: 100,
            overflowY: "auto",
          },
        }}
        disablePortal
        value={value}
        onChange={(event, newValue) => {
          if (typeof newValue === "string") {
            setValue({ title: newValue });

            setReasonCanceling(newValue);
          } else if (newValue && newValue.inputValue) {
            setValue({ title: newValue.inputValue });
            setReasonCanceling(newValue.inputValue);
          } else {
            setValue(newValue);

            setReasonCanceling(newValue);
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);
          const { inputValue } = params;

          const isExisting = options.some(
            (option) => inputValue === option.title
          );
          if (inputValue !== "" && !isExisting) {
            filtered.push({
              inputValue,
              title: `Add "${inputValue}"`,
            });
          }

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        id="free-solo-with-text-demo"
        options={reasons}
        getOptionLabel={(option) => {
          if (typeof option === "string") {
            return option;
          }
          if (option.inputValue) {
            return option.inputValue;
          }
          return option.title;
        }}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <div style={{ height: "50px" }}>
              <li key={key} {...optionProps}>
                {option.title}
              </li>
            </div>
          );
        }}
        // sx={{ width: 250 }}
        freeSolo
        renderInput={(params) => (
          <TextField
            className="auto-complete-text-field"
            {...params}
            label="Izaberi razlog otkazivanja"
            InputProps={{
              ...params.InputProps,
              style: { color: "black" },
            }}
            sx={{
              // Label color
              "& .MuiInputLabel-root": {
                color: "black", // before focus
              },
              "& .MuiInputLabel-root.Mui-focused": {
                color: "orange", // on focus
              },

              // Border color
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "orange", // before focus
                },
                "&:hover fieldset": {
                  borderColor: "black", // on hover
                },
                "&.Mui-focused fieldset": {
                  borderColor: "orange", // on focus
                },
              },

              // Input text color
              "& .MuiInputBase-input": {
                color: "black",
              },
            }}
          />
        )}
      />
    </div>
  );
}
